import { SVGProps } from 'react';

export function ArrowUpRightIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" {...props}>
      <g filter="url(#filter0_d_7537_23897)">
        <path
          d="M11.4375 3.5V9.1875C11.4375 9.30353 11.3914 9.41481 11.3094 9.49686C11.2273 9.57891 11.116 9.625 11 9.625C10.884 9.625 10.7727 9.57891 10.6906 9.49686C10.6086 9.41481 10.5625 9.30353 10.5625 9.1875V4.55602L4.30953 10.8095C4.22744 10.8916 4.1161 10.9377 4 10.9377C3.8839 10.9377 3.77256 10.8916 3.69047 10.8095C3.60838 10.7274 3.56226 10.6161 3.56226 10.5C3.56226 10.3839 3.60838 10.2726 3.69047 10.1905L9.94398 3.9375H5.3125C5.19647 3.9375 5.08519 3.89141 5.00314 3.80936C4.92109 3.72731 4.875 3.61603 4.875 3.5C4.875 3.38397 4.92109 3.27269 5.00314 3.19064C5.08519 3.10859 5.19647 3.0625 5.3125 3.0625H11C11.116 3.0625 11.2273 3.10859 11.3094 3.19064C11.3914 3.27269 11.4375 3.38397 11.4375 3.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
